export function makeSort(obj, screen) {

    const sort = obj;
    if (screen === "users") {
        if (obj.sort === "userId") {
            sort.sort = "userId"
        }
    }
    return sort;
}
export function findIdFieldDetail(obj) {
    const arr = Object.keys(obj);
    for (let i = 0; i < arr.length; i++) {
        let key = arr[i].toLowerCase();
        if (key.includes("id")) {
            return arr[i];
        }
    }
    return;
}
export function findFileIdFieldDetail(obj) {
    const arr = Object.keys(obj);
    for (let i = 0; i < arr.length; i++) {
        let key = arr[i].toLowerCase();
        if (key.includes("fileId")) {
            return arr[i];
        }
    }
    return;
}

export function convertFromCamelCase(str) {
    return str
        .replace(/(_|-)/g, ' ')
        .trim()
        .replace(/\w\S*/g, function (str) {
            return str.charAt(0).toUpperCase() + str.substr(1)
        })
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
}

export function debounce(func, timeout = 1800) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

export function makeFilters(obj, screen) {

    const filter = {};
    const search = {};

    Object.keys(obj).forEach(key => {
        let value = obj[key];
        if (screen === "USER_LISTING") {

            // User Filter
            if (key === "createdDate") {
                filter[key] = value;
            } else if (key === "company") {
                filter[key] = value.toLowerCase();
            }

        } else return {};
    })
    return { filter: filter, search: search };
}


export function convertTimestamptoDateWithTime(timestamp) {
    if (!timestamp) {
        return "-";
    }
    const dateObj = new Date(timestamp);
    const year = dateObj.getFullYear();
    let month = dateObj.getMonth() + 1;
    let date = dateObj.getDate();
    if (date < 10) date = "0" + date;
    if (month < 10) month = "0" + month;
    let totalDate = [year, month, date].join("-");
    let hrs = dateObj.getHours();
    let mints = dateObj.getMinutes();
    let seconds = dateObj.getSeconds();
    if (hrs < 10) hrs = `0${hrs}`;
    if (mints < 10) mints = `0${mints}`;
    if (seconds < 10) seconds = `0${seconds}`;
    let totalTime = hrs + ":" + mints + ":" + seconds;
    return [totalDate, totalTime].join("  ");

}
export function getTimeFromTimestamp(timestamp) {
    if (!timestamp) return "-";

    const dateObj = new Date(timestamp);

    const hrs = String(dateObj.getHours()).padStart(2, '0');
    const mins = String(dateObj.getMinutes()).padStart(2, '0');
    const secs = String(dateObj.getSeconds()).padStart(2, '0');

    return `${hrs}:${mins}:${secs}`;
}

export function convertTimestamptoDay(timestamp) {
    if (!timestamp) {
        return "-";
    }
    const dateObj = new Date(timestamp);
    let day = dateObj.getDate();
    return day
}
export function convertTimestamptoMonth(timestamp) {
    if (!timestamp) {
        return "-";
    }
    const date = new Date(timestamp);
    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    return monthNames[date.getMonth()];
}

export function convertTimestamptoYear(timestamp) {
    if (!timestamp) {
        return "-";
    }
    const dateObj = new Date(timestamp);
    let year = dateObj.getFullYear();
    return year;
}

export function formatAMPM(timestamp) {
    const date = new Date(timestamp);
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}

export function convertTimestamptoDate(timestamp) {
    if (!timestamp) {
        return "-";
    }
    const dateObj = new Date(timestamp);
    const year = dateObj.getFullYear();
    let month = dateObj.getMonth() + 1;
    let date = dateObj.getDate();
    if (date < 10) date = "0" + date;
    if (month < 10) month = "0" + month;
    return [year, month, date].join("-");

}

export function convertToHumanize(array, type) {
    function humanize(str) {
        var i, frags = str.split('_');
        for (i = 0; i < frags.length; i++) {
            frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
        }
        return frags.join(' ');
    }
    const array2 = []
    array.forEach((item) => {
        if (type === "roles") {
            array2.push({ key: humanize(item), value: item })
        } if (type === "teamLeads") {
            array2.push({ key: humanize(item), value: item })
        } else if (type === "teamLeadsAssign") {
            array2.push({ key: humanize(item), value: item })
        }
        else if (type === "teleCallerAssign") {
            array2.push({ key: humanize(item), value: item })
        }
        else if (type === "reportingTo") {
            array2.push({ key: item.split("@")[0], value: item })
        }
    })
    return array2;
}
export function convertToHumanize5(array, type) {
    function humanize(str) {
        var i, frags = str.split('_');
        for (i = 0; i < frags.length; i++) {
            frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1).toLowerCase();
        }
        return frags.join(' ');
    }
    const array2 = [];
    // Handle object input for reportingTo
    if (type === "reportingTo" && array && typeof array === "object" && !Array.isArray(array)) {
        Object.keys(array).forEach(email => {
            // Show email as label, and role in parenthesis
            const role = array[email];
            let roleLabel = "";
            if (role && typeof role === "string") {
                // Remove "ROLE_" prefix and humanize
                roleLabel = humanize(role.replace(/^ROLE_/, ''));
            }
            array2.push({
                key: `${email.split("@")[0]}${roleLabel ? " (" + roleLabel + ")" : ""}`,
                value: email,
            });
        });
        return array2;
    }
    // Default: handle array input
    if (Array.isArray(array)) {
        array.forEach((item) => {
            if (type === "roles") {
                array2.push({ key: humanize(item), value: item });
            } else if (type === "teamLeads") {
                array2.push({ key: humanize(item), value: item });
            } else if (type === "teamLeadsAssign") {
                array2.push({ key: humanize(item), value: item });
            } else if (type === "reportingTo") {
                array2.push({ key: item.split("@")[0], value: item });
            }
        });
    }
    return array2;
}


export function convertFromCamelCaseToHumanize(data) {
    let resArr = [];
    for (const property in data) {
        let innerAnsArr = [];
        let curr = data[property]
        for (const item in curr) {
            if (item.match("createdDate") || item.match("lastUpdated")) {
                let obj = {
                    key: item, value: convertTimestamptoDate(curr[item]), label: convertFromCamelCase(item).toUpperCase()
                }
                innerAnsArr.push(obj);
            } else {
                let obj = {
                    key: item, value: curr[item], label: convertFromCamelCase(item).toUpperCase()
                }
                innerAnsArr.push(obj);
            }

        }
        let objOuter = {
            key: property, value: innerAnsArr, label: convertFromCamelCase(property).toUpperCase()
        }
        resArr.push(objOuter);

    }
    return resArr;
}
const isLiteralObject = (a) => {
    return (!!a) && (a.constructor === Object);
};
// export function convertFromCamelCaseToHumanizeWithGroup2(formatedData, MainData) {
//     let resArr = [];

//     for (const property in formatedData) {
//         let innerAnsArr = [];
//         let curr = formatedData[property]
//         let currentObjValue = MainData[property];
//         if (isLiteralObject(currentObjValue) && currentObjValue != null) {
//             if (currentObjValue != null) {
//                 for (const item in currentObjValue) {
//                     if (item.match("createdDate") || item.match("lastUpdated")) {
//                         let obj = {
//                             key: item, value: convertTimestamptoDate(currentObjValue[item]), label: convertFromCamelCase(item).toUpperCase()
//                         }
//                         innerAnsArr.push(obj);
//                     } else {
//                         if (currentObjValue[item]) {
//                             let obj = {
//                                 key: item, value: currentObjValue[item], label: convertFromCamelCase(item).toUpperCase()
//                             }
//                             innerAnsArr.push(obj);
//                         }
//                     }

//                 }
//             }
//         } else {
//             if (!["cardAddress", "loanAddress", "cardUserDetail", "loanUserDetail"].includes(property)) {
//                 for (const item in curr) {
//                     if (item.match("createdDate") || item.match("lastUpdated")) {
//                         let obj = {
//                             key: item, value: convertTimestamptoDate(MainData[item]), label: convertFromCamelCase(item).toUpperCase()
//                         }
//                         innerAnsArr.push(obj);
//                     } else {
//                         if (MainData[item]) {
//                             let obj = {
//                                 key: item, value: MainData[item], label: convertFromCamelCase(item).toUpperCase()
//                             }
//                             innerAnsArr.push(obj);
//                         }

//                     }
//                 }
//             }
//         }
//         let objOuter = {
//             key: property, value: innerAnsArr, label: convertFromCamelCase(property).toUpperCase()
//         }
//         resArr.push(objOuter);

//     }
//     return resArr;
// }
export function convertFromCamelCaseToHumanizeWithGroup2(formatedData, MainData) {
    const resArr = [];
    const dateKeys = ["createdDate", "lastUpdated"];
    const excludeKeys = ["cardAddress", "loanAddress", "cardUserDetail", "loanUserDetail"];

    for (const property in formatedData) {
        const innerAnsArr = [];
        const currentData = MainData[property];
        const currentFormatted = formatedData[property];

        if (isLiteralObject(currentData) && currentData != null) {
            processItems(currentData, innerAnsArr);
        } else if (!excludeKeys.includes(property)) {
            processItems(currentFormatted, innerAnsArr, MainData);
        }

        resArr.push({
            key: property,
            value: innerAnsArr,
            label: convertFromCamelCase(property).toUpperCase(),
        });
    }

    return resArr;

    function processItems(data, resultArray, mainData = data) {
        for (const item in data) {
            if (dateKeys.some(key => item.includes(key))) {
                resultArray.push(createObject(item, convertTimestamptoDate(mainData[item])));
            } else if (mainData[item]) {
                resultArray.push(createObject(item, mainData[item]));
            }
        }
    }

    function createObject(key, value) {
        return {
            key,
            value,
            label: convertFromCamelCase(key).toUpperCase(),
        };
    }
}


export function convertFromCamelCaseToHumanizeWithGroup(FormatedData, MainData) {
    let resArr = [];
    for (const property in FormatedData) {
        let innerAnsArr = [];
        let curr = FormatedData[property]
        for (const item in curr) {
            if (item.match("createdDate") || item.match("lastUpdated")) {
                let obj = {
                    key: item, value: convertTimestamptoDate(MainData[item]), label: convertFromCamelCase(item).toUpperCase()
                }
                innerAnsArr.push(obj);
            } else {
                if (MainData[item]) {
                    let obj = {
                        key: item, value: MainData[item], label: convertFromCamelCase(item).toUpperCase()
                    }
                    innerAnsArr.push(obj);
                }

            }

        }
        let objOuter = {
            key: property, value: innerAnsArr, label: convertFromCamelCase(property).toUpperCase()
        }
        resArr.push(objOuter);

    }
    return resArr;
}
// export function convertObjectToArray2(data) {
//     let resArr = [];
//     for (const item in data) {
//         if (isLiteralObject(data[item])) {
//             let currentObj = data[item];
//             for (const val in data[item]) {
//                 if (["cardAddress", "loanAddress", "cardUserDetail", "loanUserDetail"].includes(item)) {
//                     if (
//                         val.match("createdDate")
//                         || val.match("lastUpdated") ||
//                         val.contains("Date")
//                     ) {
//                         let obj = {
//                             key: `card${val}`, value: convertTimestamptoDateWithTime(currentObj[val]), label: convertFromCamelCase(`card ${val}`).toUpperCase()
//                         }
//                         resArr.push(obj);
//                     } else if (typeof currentObj[val] === 'boolean') {
//                         let obj = {
//                             key: `card${val}`, value: currentObj[val] === true ? "YES" : "NO", label: convertFromCamelCase(`card ${val}`).toUpperCase()
//                         }
//                         resArr.push(obj);
//                     } else {
//                         let obj = {
//                             key: `card${val}`, value: currentObj[val] ?? "-", label: convertFromCamelCase(`card ${val}`).toUpperCase()
//                         }
//                         resArr.push(obj);
//                     }
//                 }
//             }
//         } else {
//             if (
//                 item.match("createdDate")
//                 || item.match("lastUpdated")
//                 || item.match("bureauFetchAt")
//             ) {
//                 let obj = {
//                     key: item, value: convertTimestamptoDateWithTime(data[item]), label: convertFromCamelCase(item).toUpperCase()
//                 }
//                 resArr.push(obj);
//             } else if (typeof data[item] === 'boolean') {
//                 let obj = {
//                     key: item, value: data[item] === true ? "YES" : "NO", label: convertFromCamelCase(item).toUpperCase()
//                 }
//                 resArr.push(obj);
//             } else {
//                 let obj = {
//                     key: item, value: data[item] ?? "-", label: convertFromCamelCase(item).toUpperCase()
//                 }
//                 resArr.push(obj);
//             }
//         }
//     }
//     return resArr;
// }
export function convertObjectToArray2(data) {
    const resArr = [];
    const specialKeys = ["cardAddress", "loanAddress", "cardUserDetail", "loanUserDetail"];
    const dateKeys = ["createdDate", "lastUpdated", "bureauFetchAt"];

    for (const item in data) {
        const currentValue = data[item];

        if (isLiteralObject(currentValue)) {
            if (specialKeys.includes(item)) {
                for (const key in currentValue) {
                    const value = currentValue[key];
                    resArr.push(createObject(`card${key}`, value, `card ${key}`));
                }
            }
        } else {
            resArr.push(createObject(item, currentValue, item));
        }
    }

    function createObject(key, value, label) {
        let formattedValue;
        if (dateKeys.some(dateKey => key.includes(dateKey))) {
            formattedValue = convertTimestamptoDateWithTime(value);
        } else if (typeof value === 'boolean') {
            formattedValue = value ? "YES" : "NO";
        } else {
            formattedValue = value ?? "-";
        }
        return {
            key,
            value: formattedValue,
            label: convertFromCamelCase(label).toUpperCase(),
        };
    }

    return resArr;
}


export function convertObjectToArray(data) {
    let resArr = [];
    for (const item in data) {
        if (
            item.match("createdDate")
            || item.match("lastUpdated")
            || item.match("bureauFetchAt")
        ) {
            let obj = {
                key: item, value: convertTimestamptoDateWithTime(data[item]), label: convertFromCamelCase(item).toUpperCase()
            }
            resArr.push(obj);
        } else if (typeof data[item] === 'boolean') {
            let obj = {
                key: item, value: data[item] === true ? "YES" : "NO", label: convertFromCamelCase(item).toUpperCase()
            }
            resArr.push(obj);
        } else if (Array.isArray(data[item])) {
            let obj = {
                key: item, value: data[item].join(" , "), label: convertFromCamelCase(item).toUpperCase()
            }
            resArr.push(obj);
        }
        else {
            let obj = {
                key: item, value: data[item] ?? "-", label: convertFromCamelCase(item).toUpperCase()
            }
            resArr.push(obj);
        }
    }
    return resArr;
}

export function convertStringArrayToKeyValueArray(data) {
    let resArr = [];
    for (let i = 0; i < data.length; i++) {
        let obj = {
            id: data[i], key: data[i], value: data[i]
        }
        resArr.push(obj);
    }
    return resArr;
}

export function convertBsdToNormalText(str) {
    str = str.split("_");
    let result = "";
    for (let i = 0; i < str.length; i++) {
        let curr = str[i].toLowerCase();
        result = result.concat(" ", curr);
    }
    return result;
}


export function convertTimestampToMonthDate(timestamp) {
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    };

    const formattedDate = new Date(timestamp).toLocaleDateString('en-US', options);
    return formattedDate;
}

export function copyToClipboardFunc(str) {
    // Create a temporary input element
    const input = document.createElement('input');
    input.value = str;
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, 99999);
    document.execCommand('copy');
    document.body.removeChild(input);
};

export function getNameFromEmail(email) {
    const mail = email.split("@")[0];
    return mail ?? "-";
}

export function convertDateToTimestamp(date) {
    const dateObject = new Date(date);
    if (isNaN(dateObject.getTime())) {
        throw new Error('Invalid date');
    }
    return dateObject.getTime();
};

export function convertDateAndTimeToTimestampExtra(date, time) {
    if (!date || !time) {
        throw new Error("Date and Time are required");
    }

    const [hours, minutes] = time.split(":").map(Number);

    if (
        Number.isNaN(hours) ||
        Number.isNaN(minutes) ||
        hours < 0 ||
        hours > 23 ||
        minutes < 0 ||
        minutes > 59
    ) {
        throw new Error("Invalid time format. Expected HH:mm");
    }

    const dateObject = new Date(date);

    if (isNaN(dateObject.getTime())) {
        throw new Error("Invalid date");
    }

    dateObject.setHours(hours, minutes, 0, 0);

    return dateObject.getTime();
}